exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".note{z-index:10;padding:8px 0;background:#fffbee;text-align:center}.note_content{margin-right:10px;font-size:.8em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-45df246a!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/note.vue
// module id = 63
// module chunks = 0